export default {

	formatValue: (value: string) => {
		return value?.toUpperCase();
	},

	// Calender Formatter
	teamTypeFormatter: (value: string) => {
		switch (value) {
			case "CANCELLED":
				return "Type09";
			case "PENDING":
				return "Type01";
			case "APPROVED":
				return "Type05";
			case "AUTO_APPROVED":
				return "Type05";
		}
	},

	substituteFormatter: (value: Object) => {

		if (value) {
			return "Vertretung: " + value["firstName"] + " " + value["lastName"];
		}

	},

	dateFormatterStart: (value: string) => {
		return new Date(value);
	},

	dateFormatterEnd: (value: string) => {
		const endDate = new Date(value);
		endDate.setHours(23);
		endDate.setMinutes(59);
		return endDate;
	},

	dateFormatterShort: (value: string) => {
		return new Date(value).toLocaleDateString('de-de', { year: "numeric", month: "numeric", day: "numeric" })
	},

	dateFormatterLong: (value: string) => {
		return new Date(value).toLocaleString();
	},


	statusIcon: (value: string | boolean) => {
		switch (value) {
			case "pending":
				return "sap-icon://pending";
			case "approved":
				return "sap-icon://message-success";
			case "rejected":
				return "sap-icon://decline";
			case "forwarded":
				return "sap-icon://media-forward";
			case "removed":
				return "sap-icon://delete";
			case "active":
				return "sap-icon://message-success";
			case "inactive":
				return "sap-icon://sys-cancel";
			case "ACTIVE":
				return "sap-icon://message-success";
			case "ARCHIVED":
				return "sap-icon://sys-cancel";
			case "REMOVED":
				return "sap-icon://delete";
			case true:
				return "sap-icon://message-success";
			case false:
				return "sap-icon://sys-cancel";
		}
	},

	objectStatus: (value: string | boolean) => {
		switch (value) {
			case "true":
				return "Success";
			case true:
				return "Success";
			case "false":
				return "Error";
			case false:
				return "Error";
			case "APPROVED":
				return "Success";
			case "AUTO_APPROVED":
				return "Success";
			case "PENDING":
				return "Warning";
			case "ACTIVE":
				return "Success";
			case "ARCHIVED":
				return "None";
			case "REMOVED":
				return "None";
			case "CANCELLED":
				return "None";
			case "REJECTED":
				return "Error";
		}
	},

};
